export const supportedLocales = `
  supportedLocales {
    id
    value
  }
`;
